import { mapAbout, mapTestimonials } from "./homePage";
import { API_ENDPOINTS } from "./config";

const ABOUTS_API = API_ENDPOINTS.abouts;

let aboutPageRequest = null;

export const fetchAboutPage = async () => {
  if (aboutPageRequest) return aboutPageRequest;

  aboutPageRequest = fetch(ABOUTS_API)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch about page data (${response.status})`);
      }

      const data = await response.json();

      return {
        about: mapAbout(data.abouts?.[0]),
        testimonials: mapTestimonials(data.testimonials),
        contact: data.contacts?.[0] || null,
      };
    })
    .catch((error) => {
      aboutPageRequest = null;
      throw error;
    });

  return aboutPageRequest;
};
